export default __webpack_public_path__ + "static/media/logo.aa66f2f1.png";